export default __webpack_public_path__ + "static/thumb-11-2b717583dd81b535e6ce4655e03c61f7.jpg";